import ProjectUtils from "../../../../../../utils/project-utils.js";

export function makeApplicationsDetailsItems(data) {
    const contactCity = data?.attendance?.data ?? {};

    const empty = {
        label: "",
        value: " ",
    }

    return [
        {
            label: "Local pré-cadastrado",
            value: contactCity?.attendance_contactplace ?? "",
        },
        empty,
        {
            label: "Tipo",
            value: contactCity?.attendance_contacttype ?? "",
        },
        {
            label: "Logradouro",
            value: contactCity?.attendance_contactstreet ?? "",
        },
        empty,
        {
            label: "Número",
            value: contactCity?.attendance_contactnumber ?? "",
        },
        {
            label: "Bairro",
            value: contactCity?.attendance_contactneighborhood ?? "",
        },
        empty,
        {
            label: "Cruzamento",
            value: contactCity?.attendance_contactcrossroads ?? "",
        },
        {
            label: "Ponto de referência",
            value: contactCity?.attendance_contactreferencepoint ?? "",
        },
        empty,
        {
            label: "Município",
            value: `${contactCity?.attendance_contactcity ?? ""}`,
        },
    ];
}

export function makeIndividualItems(data, printOptions) {
    const requesterValuePrintClass = printOptions?.showRequesters ? "" : "print:hidden";

    const initialData = data?.attendance?.data ?? {};

    const contactName = initialData?.attendance_contactname ?? "";

    const contactPhone = initialData?.attendance_anonymous
        ? ""
        : initialData?.attendance_contactphone ?? "";

    const contactCpf = initialData?.attendance_anonymous
        ? ""
        : ProjectUtils.formatCpfToView(initialData?.attendance_contactcpf ?? "");

    return [
        {
            label: "Solicitante",
            children: (
                contactName ? (
                    <span className={`text-sm font-normal text-[#161616] ${requesterValuePrintClass}`}>
                        {contactName}
                    </span>
                ) : (
                    <span className={`ml-1 text-sm font-normal italic text-[rgb(137,137,137)] ${requesterValuePrintClass}`}>
                        Não informado
                    </span>
                )
            ),
        },
        {
            label: "Telefone",
            children: (
                contactPhone ? (
                    <span className={`text-sm font-normal text-[#161616] ${requesterValuePrintClass}`}>
                        {contactPhone}
                    </span>
                ) : (
                    <span className={`ml-1 text-sm font-normal italic text-[rgb(137,137,137)] ${requesterValuePrintClass}`}>
                        Não informado
                    </span>
                )
            ),
        },
        {
            label: "CPF",
            children: (
                contactCpf ? (
                    <span className={`text-sm font-normal text-[#161616] ${requesterValuePrintClass}`}>
                        {contactCpf}
                    </span>
                ) : (
                    <span className={`ml-1 text-sm font-normal italic text-[rgb(137,137,137)] ${requesterValuePrintClass}`}>
                        Não informado
                    </span>
                )
            ),
        },
    ];
}